import Navbar from 'src/components/HorizontalLayout/Navbar';
import React, { useEffect, useState } from "react"
import {
    Card,
    Col,
    Container,
    Row,
    Input,
    Modal,
    Badge,
    CardImg,
    CardBody,
    CardText,
    CardTitle,
    CardHeader,
    FormGroup,
    Label,
    Button,
} from "reactstrap";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import DataTable from "react-data-table-component";
import { useSelector, useDispatch } from "react-redux";
import { useAgency } from 'src/components/Common/agencyBrandingData';
import TableCustomLoader from '../../../components/Common/TableCustomLoader'
import { getProposals } from 'src/slices/Proposals/thunk';
import { Link } from 'react-router-dom';
import logo from "../../../assets/images/logo-sm.png";
import { useLocation } from 'react-router';
import axiosInstance from 'src/common/axiosInstance';
import exportExcelIcon from "../../../assets/images/exportexcel.png";
import { FaEdit as FaEditRaw } from 'react-icons/fa';
import { SVGProps } from 'react';

import RepportingInvoicingModal from './ReportingInvoicingModal';
import SubmitSuggestion from './SubmitSuggestion';
import SignNow from './SignNow';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import LineItemTable from './LineItemInfo';
interface Proposal {
    billing_contact_name: string;
    billing_contact_title: string;
    billing_contact_phone: string;
    billing_contact_email: string;
    primary_contact_name: string;
    primary_contact_title: string;
    primary_contact_phone: string;
    primary_contact_email: string;
    sign_date: string;
    sign_doc: string;
    detailed_order_note: string;
    pitch_notes: string;
    user_name: string;
    order_id: number;
    proposal_status: string;
    q1media_sign: string;
    q1media_users_id: number;
    account_name: string;
    order_name: string;
    amount: number;
    id: number;
    created_at: string;
    expires_at: string;
}
interface LineItem {
    line_item_name: string;
    start_date: string;
    end_date: string;
    media_type: string;
    creative_size: string;
    book_type: string;
    type_value: number;
    define_action: string;
    custom_note: string;
    geo_loc: any;
    geo_type: string;
    gross_total_budget_c: string;
    amount: number;
    kpi_ctr: number;
    kpi_cpc: number;
    kpi_cpa: number;
    kpi_view: number;
    cpm: string;
    management_fee: number;
    impressions: number;
    media_spend: number;
    spend_percentage_c: number;
    exchange: number;
    geo_name: string;
}

interface OrderInfo {
    Status: string;
    client_report_certain_day: string;
    client_need_report: string;
    special_instructions: string;
    wrap_up_detail: string;
}

type CreativeSizes = {
    [exchangeId: string]: {
        [sizeId: string]: string;
    };
};
interface OptionType {
    label: string;
    value: string;
}
const ViewProposal = () => {
    const params = useParams();
    const navigate = useNavigate();
    const proposalId = params.proposal_id;
    const location = useLocation();
    const dispatch = useDispatch();
    const { user, userError } = useSelector((state: any) => state.login);
    const agency = useAgency();
    const proposal = location.state?.proposals;
    const adminUser: any = localStorage.getItem("adminUser");
    const [proposalinfo, setProposalInfo] = useState<Proposal | null>(null);
    const [orderinfo, setOrderInfo] = useState<OrderInfo | null>(null);
    const [lineitemInfo, setLineItemInfo] = useState<LineItem[]>([]);
    const [creativeSizes, setCreativeSizes] = useState<CreativeSizes>({});
    const [searchTerm, setSearchTerm] = useState<string>("");
    const [loading, setLoading] = useState(false);
    const [hideSignNow, setHideSignNow] = useState(false);
    const [hideSubmitSuggestion, setHideSubmitSuggestion] = useState(false);
    const [clientDayArr, setClientDay] = useState<string[]>([]);  // Explicitly define the type as string[]
    const [certainDayArr, setCertainDay] = useState<OptionType[]>([]);  // Explicitly define the type as OptionType[]
    const [wrapDeck, setWrapUpDeck] = useState<OptionType[]>([]);  // Explicitly define the type as OptionType[]

    const [modalLarge, setModalLarge] = useState(false);
    const [modalLargeSuggestion, setModalLargeSuggestion] = useState(false);
    const [modalLargeSign, setModalLargeSign] = useState(false);
    // Explicitly cast to fix JSX compatibility
    const FaEdit = FaEditRaw as unknown as React.FC<SVGProps<SVGSVGElement>>;

    let decodedId = '';
    if (!proposal && proposalId) {
        try {
            decodedId = atob(proposalId);
        } catch (e) {
            navigate('/billing', { state: { message: 'No valid proposal ID found!' } });
            console.error('Invalid base64 proposal_id from URL:', proposalId);
            decodedId = ''; // fallback
        }
    }
    function togLarge() {
        setModalLarge(!modalLarge);
        removeBodyCss();
    }

    function togLargeSuggestion() {
        setModalLargeSuggestion(!modalLargeSuggestion);
        removeBodyCss();
    }

    function togLargeSign() {
        setModalLargeSign(!modalLargeSign);
        removeBodyCss();

    }
    function removeBodyCss() {
        document.body.classList.add("no_padding");
    }
    var sso = false;
    if (adminUser) {
        sso = true;
    }
    
    // Also check if current user is admin type
    if (user?.user?.user_type === 'Admin' || user?.user?.user_type === 'admin') {
        sso = true;
    }

    const updateOrderInfo = (updatedOrderInfo: OrderInfo) => {
        setOrderInfo(updatedOrderInfo); // Update parent state with the new order info
    };
    useEffect(() => {
        const fetchProposalDetails = async () => {
            try {
                setLoading(true);
                const prId = proposal?.id || decodedId;
                if (!prId) {
                    navigate('/billing', { state: { message: 'No valid proposal ID found!' } });
                    console.warn('No valid proposal ID found.');
                    setLoading(false);
                    return;
                }
                const response = await axiosInstance.get('/proposal-details', {
                    params: { proposal_id: prId, sso, agency_id: agency.data.Id }
                });
                const minLoadTime = 1000;
                await new Promise(resolve => setTimeout(resolve, minLoadTime));
                if (!response.data.status) {
                    if (response.data.redirect) {
                        toast.error(response.data.message);
                        navigate(response.data.redirect);
                    } else {
                        navigate('/billing', { state: { message: response.data.message } });
                    }
                    return;
                }

                setProposalInfo({
                    ...response.data.data.proposal, // data from the API
                    amount: response.data.data.amount, // Merge `amount` from location.state
                });
                setLineItemInfo(response.data.data.line_items || []);
                setCreativeSizes(response.data.data.creative_size);
                setOrderInfo(response.data.data.order_info);
                setLoading(false);
                setClientDay(response.data.data.client_day_arr || []);
                setCertainDay(
                    response.data.data.client_certain_day_arr
                        ? Object.entries(response.data.data.client_certain_day_arr).map(([key, value]) => ({
                            label: value as string,
                            value: key
                        }))
                        : []
                );
                setWrapUpDeck(response.data.data.wrap_up_report_arr
                    ? Object.entries(response.data.data.wrap_up_report_arr).map(([key, value]) => ({
                        label: value as string,
                        value: key
                    }))
                    : []);
            } catch (error) {
                navigate('/billing', { state: { message: "Somehting went Wrong!" } });
                console.error('Error fetching proposal details:', error);
                setLoading(false);
            }
        };

        fetchProposalDetails();
    }, []);

    useEffect(() => {
        dispatch(getProposals(user.user.users_id));
    }, []);

    return (
        <React.Fragment>
            <div className="page-content" style={{ marginTop: "0" }}>
                <Navbar />
                <Container fluid style={{ maxWidth: "100%", marginTop: 10 }}>
                    <Breadcrumbs title="Billing" breadcrumbItem="Proposals Details" titleLink="/billing"
                    />
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardBody className="pb-0">
                                    <Col lg={12} className="d-flex justify-content-between align-items-center mb-3">
                                        <h4 className="mb-0">Review & Sign</h4>
                                         {/* show on desktop only */}
                                        <Link to="/billing" >
                                            <button
                                                rel="noreferrer"
                                                className="btn btn-primary button-primary align-items-center"
                                            >
                                                <img
                                                    src="/assets/icons/dropdown.svg"
                                                    alt="Back"
                                                    style={{ width: "16px", height: "16px", marginRight: "6px", verticalAlign: "middle", transform: "rotate(90deg) scale(1.5)", filter: "invert(100%" }}
                                                />
                                                Back to List
                                            </button>
                                        </Link>
                                    </Col>

                                    <div className="row align-items-start">
                                        <div className="col-12 col-md-4 mb-3">
                                            <div className="d-flex justify-content-between align-items-center mb-1">
                                            <div
                                                className="mb-2"
                                                style={{
                                                    background: "white",
                                                    width: "40px",
                                                    height: "40px",
                                                    borderRadius: "4px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    padding: "4px"
                                                }}
                                            >
                                                <img src={logo} alt="logo" style={{ height: "28px", width: "auto" }} />
                                            </div>
                                             {/* show on mobile only */}
                                        <div className='d-block d-md-none'>
                                            {(() => {
                                                let status = proposalinfo?.proposal_status;
                                                if (status === 'Pending Signature' || status === 'Sent To Client') {
                                                    status = 'Ready for Your Signature';
                                                }
                                                return (
                                                    <span
                                                        className={`badge font-size-16 ${proposalinfo?.proposal_status === 'Signed'
                                                            ? 'badge-success-subtle'
                                                            : 'badge-purple-subtle'
                                                            }`}
                                                    >
                                                        {status}
                                                    </span>
                                                );
                                            })()}
                                        </div>
                                        </div>
                                            <div className="text-muted small">
                                                <p className="mb-1">8240 N Mopac Expy STE 250, Austin, TX</p>
                                                <p className="mb-1"><i className="uil uil-envelope-alt me-1"></i> Successteam@q1media.com</p>
                                                <p className="mb-0"><i className="uil uil-phone me-1"></i> (512)-388-2300</p>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-5 mb-3">
                                            <h6 className="mb-2">Billed To:</h6>
                                           
                                            <div>
                                                {(proposalinfo?.primary_contact_email == proposalinfo?.billing_contact_email) ? (
                                                    <div>
                                                         <label className="d-block" >Primary & Billing Contact:</label>
                                                        <div className="mt-1">
                                                            <p className="mb-1 text-muted">{proposalinfo?.billing_contact_name}</p>
                                                            <p className="mb-1 text-muted">{proposalinfo?.billing_contact_title}</p>
                                                            {proposalinfo?.billing_contact_email && <p className="mb-1 text-muted"><i className="uil uil-envelope-alt me-1"></i>{proposalinfo?.billing_contact_email}</p>}
                                                            {proposalinfo?.billing_contact_phone && <p className="mb-1 text-muted"><i className="uil uil-phone me-1"></i>{proposalinfo?.billing_contact_phone}</p>}
                                                        </div>
                                                    </div>
                                                ) : (
                                                    <div>
                                                        <div className='mb-2'>
                                                            <label className='text-muted'>Primary Contact:</label>
                                                            <div className="mt-1">
                                                                <p className="mb-0 text-muted">{proposalinfo?.primary_contact_name}</p>
                                                                <p className="mb-0 small text-muted">{proposalinfo?.primary_contact_title}</p>
                                                                {proposalinfo?.primary_contact_email && <p className="mb-0 small"><i className="uil uil-envelope-alt me-1"></i>{proposalinfo?.primary_contact_email}</p>}
                                                                {proposalinfo?.primary_contact_phone && <p className="mb-0 small"><i className="uil uil-phone me-1"></i>{proposalinfo?.primary_contact_phone}</p>}
                                                            </div>
                                                        </div>
                                                        <div className="mb-2">
                                                            <label className='text-muted'>Billing Contact:</label>
                                                            <div className="mt-1">
                                                                <p className="mb-0 text-muted">{proposalinfo?.billing_contact_name}</p>
                                                                <p className="mb-0 small text-muted">{proposalinfo?.billing_contact_title}</p>
                                                                {proposalinfo?.billing_contact_email && <p className="mb-0 small"><i className="uil uil-envelope-alt me-1"></i>{proposalinfo?.billing_contact_email}</p>}
                                                                {proposalinfo?.billing_contact_phone && <p className="mb-0 small"><i className="uil uil-phone me-1"></i>{proposalinfo?.billing_contact_phone}</p>}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {/* Proposal Details Column */}
                                        <div className='col-12 col-md-3'>
                                            <div className='d-flex flex-column'>
                                                {/* Status Badge - Desktop only */}
                                                <div className='mb-2 d-none d-md-flex justify-content-end'>
                                                    {(() => {
                                                        let status = proposalinfo?.proposal_status;
                                                        if (status === 'Pending Signature' || status === 'Sent To Client') {
                                                            status = 'Ready for Signature';
                                                        }
                                                        return (
                                                            <span
                                                                className={`badge ${proposalinfo?.proposal_status === 'Signed'
                                                                    ? 'badge-success-subtle'
                                                                    : 'badge-purple-subtle'
                                                                    }`}
                                                            >
                                                                {status}
                                                            </span>
                                                        );
                                                    })()}
                                                </div>
                                                
                                                <div className='d-flex justify-content-between align-items-center mb-1'>
                                                    <label className="d-block" style={{ marginBottom: "4px" }}>Proposal #:</label>
                                                    <div className="mb-0 text-muted">#{proposalinfo?.id}</div>
                                                </div>
                                                
                                                <div className='d-flex justify-content-between align-items-center mb-1'>
                                                     <label className="d-block" style={{ marginBottom: "4px" }}>Total:</label>
                                                    <div className="mb-0 text-muted">{proposalinfo?.amount ? "$" + Number(proposalinfo.amount).toLocaleString(undefined, { minimumFractionDigits: 2 }) : '$0.00'}</div>
                                                </div>
                                                
                                                {proposalinfo?.sign_date && (
                                                    <div className='d-flex justify-content-between align-items-center'>
                                                        <label className="d-block" style={{ marginBottom: "4px" }}>Signed:</label>
                                                    <div className="mb-0 text-muted">{proposalinfo.sign_date}</div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="my-3" />
                                    <Row>
                                        <Col sm={12}>
                                            <div className='d-flex justify-content-between align-items-start mb-3'>
                                                <div>
                                                    <label className="d-block" style={{ marginBottom: "4px" }}>Campaign Summary</label>
                                                    <div className="mb-0 text-muted">{proposalinfo?.order_name}</div>
                                                </div>
                                                {proposalinfo?.sign_doc && (
                                                    <div><a href={proposalinfo?.sign_doc}>
                                                        <img
                                                            id="export_excel"
                                                            className="cursor-pointer"
                                                            style={{ cursor: "pointer" }}
                                                            width={48}
                                                            height={42}
                                                            src={exportExcelIcon}
                                                            title='Export Signed IO'
                                                            alt="Export to Excel"
                                                        /></a>
                                                    </div>
                                                )}
                                            </div>
                                            {(proposalinfo?.detailed_order_note || proposalinfo?.pitch_notes) && (
                                                <Row className="mt-3">
                                                    {proposalinfo?.detailed_order_note && (
                                                        <Col sm={6}>
                                                            <label className="text-muted">Campaign Notes</label>
                                                            <ul className="small mt-0" style={{ paddingLeft: '18px' }}>
                                                                {proposalinfo?.detailed_order_note
                                                                    ?.split("•")
                                                                    .filter(point => point.trim() !== "")
                                                                    .map((point, index) => (
                                                                        <li key={index}>{point.trim()}</li>
                                                                    ))}
                                                            </ul>
                                                        </Col>
                                                    )}
                                                    {proposalinfo?.pitch_notes && (
                                                        <Col sm={6}>
                                                            <small className="text-muted">Message From {proposalinfo?.user_name}</small>
                                                            <p className="small mt-1">{proposalinfo?.pitch_notes}</p>
                                                        </Col>
                                                    )}
                                                </Row>
                                            )}
                                        </Col>

                                    </Row>
                                    <hr className="my-3" />

                                    <Row>
                                        <Col md={12}>
                                            <Card>
                                                <CardHeader>
                                                    <div className="d-flex justify-content-between">
                                                        <h3 className="mb-0"><CardTitle>Reporting & Invoicing Details</CardTitle></h3>
                                                        <div className="text-end">
                                                            {orderinfo?.Status && !['Cancelled', 'Ended', 'Finished'].includes(orderinfo?.Status) && (
                                                                <FaEdit className="edit-order-reporting" aria-label="Edit"
                                                                    onClick={togLarge} style={{ cursor: "pointer" }} />
                                                            )}
                                                        </div>
                                                    </div>
                                                </CardHeader>
                                                <CardBody>
                                                    <Row>
                                                        <Col sm="6">
                                                            <label className="d-block" style={{ marginBottom: "4px" }}>How often do you need a report?</label>
                                                            <div className="text-muted">
                                                                {orderinfo?.client_need_report}
                                                            </div>
                                                        </Col>
                                                        <Col sm="6">
                                                            <label className="d-block" style={{ marginBottom: "4px" }}>Is there a certain day of the week you would like to receive reports?</label>
                                                            <div className="text-muted">
                                                                {orderinfo?.client_report_certain_day?.length
                                                                    ? JSON.parse(orderinfo?.client_report_certain_day).join(', ')
                                                                    : ''}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mt-3">
                                                        <Col sm="6">
                                                            <label className="d-block" style={{ marginBottom: "4px" }}>What specific details would you like to see in the campaign Wrap-Up Report?</label>
                                                            <div className="text-muted">
                                                                {orderinfo?.wrap_up_detail}
                                                            </div>
                                                        </Col>
                                                        <Col sm="6">
                                                            <label className="d-block" style={{ marginBottom: "4px" }}>Special Invoice Instructions:</label>
                                                            <div className="text-muted">
                                                                {orderinfo?.special_instructions}
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </CardBody>
                                            </Card>
                                        </Col>

                                        <RepportingInvoicingModal
                                            isOpen={modalLarge}
                                            toggle={togLarge}
                                            client_day={clientDayArr}
                                            certain_day={certainDayArr}
                                            wrap_deck={wrapDeck}
                                            order_id={proposalinfo?.order_id ?? 0}
                                            orderinfo={orderinfo}
                                            onUpdate={updateOrderInfo}
                                        />
                                    </Row>
                                    <div className="py-2">
                                        <Col sm="12">
                                            <div className='d-flex gap-3  flex-column flex-sm-row justify-content-between'>
                                                    <h5 className="font-size-18 mb-0">Line Items Summary</h5>
                                                    <Input
                                                        type="text"
                                                        placeholder="Search"
                                                        value={searchTerm}
                                                        className='responsive-input'
                                                        onChange={(e) => setSearchTerm(e.target.value)}
                                                        style={{ marginBottom: '16px', padding: '10px' ,height:"38px"}}
                                                    />
                                                </div>
                                        </Col>
                                        <div className="table-responsive">
                                            {loading ? (
                                                <TableCustomLoader length={2}
                                                    message="Almost ready! Finalizing Line Item data." />
                                            ) : (
                                                <LineItemTable
                                                    lineitemInfo={lineitemInfo}
                                                    creativeSizes={creativeSizes}
                                                    searchTerm={searchTerm}
                                                />
                                            )}
                                            <br></br>
                                            <div className="float-end">
                                                <th scope="row" colSpan={4} className="border-0 text-end">Total: </th>
                                                <td className="border-0 text-end"><h4 className="m-0 fw-semibold"><p>{proposalinfo?.amount ? "$" + Number(proposalinfo.amount).toLocaleString(undefined, { minimumFractionDigits: 2 }) : '$0.00'}</p></h4></td>
                                            </div>
                                        </div>

                                        <div className="d-print-none mt-4">
                                            <div className="float-end">
                                                {['sent to client', 'pending signature'].includes(proposalinfo?.proposal_status?.toLowerCase() ?? '') && !hideSubmitSuggestion && (
                                                    <Button className="btn btn-primary me-3" style={{ backgroundColor: "#038edc" }} onClick={() => togLargeSuggestion()}>Submit Suggestion</Button>
                                                )}
                                                {['sent to client', 'revised io', 'pending signature'].includes(proposalinfo?.proposal_status?.toLowerCase() ?? '') && !hideSignNow && (
                                                    <Button className="btn btn-primary me-3" style={{ backgroundColor: "#038edc" }} onClick={() => togLargeSign()}>
                                                        Sign Now
                                                    </Button>
                                                )}

                                            </div>
                                        </div>
                                        <SubmitSuggestion
                                            isOpen={modalLargeSuggestion}
                                            toggle={togLargeSuggestion}
                                            proposal_id={proposalinfo?.id || 0}
                                            setHideSignNow={setHideSignNow}
                                            setHideSubmitSuggestion={setHideSubmitSuggestion}
                                        />
                                        <SignNow
                                            isOpen={modalLargeSign}
                                            toggle={togLargeSign}
                                            proposal_id={proposalinfo?.id || 0}
                                            session_user_name={user.user.name}
                                            q1_user_name={proposalinfo?.user_name || ""}
                                            q1_user_sign={proposalinfo?.q1media_sign || ""}
                                            q1media_users_id={proposalinfo?.q1media_users_id || 0}
                                            amount={proposalinfo?.amount || 0}
                                            account_name={proposalinfo?.account_name ?? ""}
                                            setHideSignNow={setHideSignNow}
                                            setHideSubmitSuggestion={setHideSubmitSuggestion}
                                        />
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>

    );
}

export default ViewProposal;


